quoteModule.factory("SingleProductCoordinationInfo", function() {

    var ProdFlags = function() {
        this.hasCoverages = false;
        this.hasDeductibles = false;
        this.hasUpgrades = false;
        this.hasUpgradeDeductibles = false;
        this.isIncomplete = false;
        this.hasSurcharges = false;
    }

    var UpgradeProductData = function(){
        this.baseNoUpgradeTerm = null;
        this.upgradeProductId = null;
        this.upgradeProdFull = null;
        this.upgradeProductName= null;
        this.upgradeCoverages= [];
        this.upgradeDeductibles= [];
        this.upgradeOptions = [];
    }
    var SingleProductCoordinationInfo = function(){
        this.fullProductData = null;
        this.productFlags = new ProdFlags();
        this.availableCoverages = [];
        this.availableDeductibles = [];
        this.availableOptions = [];
        this.baseNoUpgradeTerms = [];
        this.upgradeProducts= [new UpgradeProductData()];
        this.cachedResponseId = "";
        this.incompleteFields = [];
    }
    return SingleProductCoordinationInfo;
});

